import { Routes } from '@angular/router';
import { Authority } from '@app/shared/utils/enums';
import { CradlepointProvisioningComponent } from './cradlepoint-provisioning.component';

export const cradlepointProvisioningRoutes: Routes = [
    {
        path: 'cradlepoint-provisioning',
        children: [
            {
                path: '',
                component: CradlepointProvisioningComponent,
                data: {
                    authorities: [Authority.ADMIN, Authority.UPDATE, Authority.CRADLEPOINT_PRO, Authority.INTL]
                }
                //,canActivate: [RouteAccessGuard]
            }
        ]
    }
]